import { PrinterPosPlusOutlineIcon } from './PrinterPosPlusOutlineIcon';

/**
 * author: Colton Wiscombe
 * id B842534E-FF25-45A4-B2E1-F5FC581FD017
 * name printer-pos-plus-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-plus-outline.svg
 * tags
 * - Printer 
 */
export const PrinterReceiptPlusOutlineIcon = PrinterPosPlusOutlineIcon;
export default PrinterReceiptPlusOutlineIcon